var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 8.25H15V15.75H12.75V17.25H18.75V15.75H16.5V8.25H18.75V6.75H12.75V8.25ZM9.75 6.75H6.75C5.92275 6.75 5.25 7.42275 5.25 8.25V17.25H6.75V13.5H9.75V17.25H11.25V8.25C11.25 7.42275 10.5773 6.75 9.75 6.75ZM6.75 12V8.25H9.75V12H6.75Z",
    fill: "#A93AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai-icon.3f3af8f84eadd3d4207f8ed8a822ae7f.svg";
export { ForwardRef as ReactComponent };